<template>
  <b-img
    v-bind="logoProps"
    :src="require(`../../assets/sheild.png`)"
    alt="logo"
  />
  <!-- <b-img v-else v-bind="logoProps" :src="require('../../assets/platform-logo.png')" alt="logo" /> -->
</template>
<script>
export default {
  data() {
    return {
      platform: "default"
    };
  },
  props: {
    logoProps: Object
  },
  mounted() {
    let aa = `aa${process.env.VUE_APP_CURRENT_PLATFORM}`;
    // this.platform = process.env.VUE_APP_CURRENT_PLATFORM == 'adit' ? 'adit' : 'default'
    this.platform = process.env.VUE_APP_CURRENT_PLATFORM;
  }
};
</script>